import React, { ReactNode } from 'react';
import { makeStyles, MenuItem, MenuItemProps } from '@material-ui/core';

import styles from './SelectItem.module.css';

export const SelectItem = React.forwardRef(({ children, classes, ...props }: Omit<MenuItemProps, 'button'>, ref) => {
  const itemUseStyles = makeStyles({
    root: {
      fontFamily: 'var(--ff-etelka-text)',
      fontSize: 12,
      color: '#222736',
      padding: '9px 8px',
      borderBottom: '1px solid #EEEFF3',
      fontStyle: 'normal',
      fontWeight: 'normal',
      '&:last-child': {
        borderWidth: 0,
      },
    },
  });

  return (
    <MenuItem classes={{ ...itemUseStyles(), ...classes }} innerRef={ref} {...props}>
      {children}
    </MenuItem>
  );
});

type SelectInnerItemPropsType = {
  label: ReactNode;
  value: ReactNode;
};

export const SelectInnerItem = ({ label, value }: SelectInnerItemPropsType) => (
  <div className={styles.itemWrapper}>
    <span className={styles.itemName}>{label}</span>
    <span className={styles.itemAccount}>{value}</span>
  </div>
);
